<template>
  <main class="ap-page">
    <!-- HERO -->
    <header class="ap-hero">
      <div class="ap-hero-inner">
        <div class="ap-underLogoPhrase">
          <h1 class="font-weight-bold mb-4 centers">
            <span class="marker">S.O.S</span>
          </h1>
        </div>
      </div>
    </header>

    <!-- CONTENT -->
    <section class="ap-content">
      <!-- EMPTY -->
 

      <!-- GRID (uniform cards) -->
      <div class="grid">
        <router-link
          v-for="animau in animauxFiltres"
          :key="animau.id"
          :to="'/animaux/' + animau.id"
          class="card"
        >
          <!-- IMAGE -->
          <div class="cardMedia">
            <img
              :src="'https://admin.asso-refuge.fr/images/' + animau.img1"
              :alt="`Photo ${animau.type} ${animau.name}`"
              :title="animau.name + ' ' + animau.race"
              loading="lazy"
            />

            <div class="mediaOverlay"></div>

            <div class="mediaTop">
              <span class="tag tagType">
                {{ animau.type === 'chien' ? '🐶 Chien' : animau.type === 'chat' ? '🐱 Chat' : animau.type }}
              </span>
           
            </div>

            <div class="mediaBottom" v-if="animau.ville">
              <span class="tag tagCity">📍 {{ animau.ville }}</span>
            </div>
          </div>

          <!-- BODY -->
          <div class="cardBody">
            <div class="titleRow">
              <h3 class="name">
                <span class="markerSmall">{{ animau.name }}</span>
              </h3>
              <span class="miniHeart">❤</span>
            </div>

            <p v-if="animau.race" class="meta">{{ animau.race }}</p>

              <span v-if="animau.naissance" class="tag">
                {{ calculateAge(animau.naissance) }}
              </span>

            <p class="alert" v-if="animau.huge_information">
              {{ animau.huge_information }}
            </p>

            <div class="footer">
              <span class="cta">
                Voir la fiche <span class="arrow">→</span>
              </span>
            </div>
          </div>
        </router-link>
      </div>
    </section>
  </main>
</template>

<script>
import convertAge from "../components/getAge.js";

export default {
  data() {
    return {
      animaux: [],
      lastUpdateChien: null,
      lastUpdateChat: null,
      filtres: {
        type: "",
        sexe: "",
        couleur: "",
        age: "",
        ville: ""
      }
    };
  },

  computed: {
    animauxFiltres() {
      const { type, sexe, couleur, age, ville } = this.filtres;

      return this.animaux
        .filter(animal => {
          if (type && animal.type !== type) return false;
          if (sexe && animal.sexe !== sexe) return false;
          if (couleur && animal.couleur !== couleur) return false;
          if (ville && animal.ville !== ville) return false;

          if (age) {
            const mois = this.ageEnMois(animal.naissance);
            if (age === "bebe" && mois >= 6) return false;
            if (age === "ado" && (mois < 6 || mois > 24)) return false;
            if (age === "adulte" && mois <= 24) return false;
          }

          return true;
        })
        .sort((a, b) => {
          const da = a.created_at ? new Date(a.created_at) : new Date(0);
          const db = b.created_at ? new Date(b.created_at) : new Date(0);
          return db - da;
        });
    }
  },

  watch: {
    "$route.query.type": {
      immediate: true,
      handler(type) {
        this.filtres.type = type || "";
      }
    }
  },

  mounted() {
    const idSite = this.$idSite;

    fetch(`https://admin.asso-refuge.fr/getSos/${idSite}`)
      .then(res => res.json())
      .then(data => {
        this.animaux = Array.isArray(data) ? data : [];
        this.calculerDernieresMAJ();
      })
      .catch(err => console.error("Erreur chargement animaux :", err));
  },

  methods: {
    resetFiltres() {
      this.filtres = {
        type: this.$route.query.type || "",
        sexe: "",
        couleur: "",
        age: "",
        ville: ""
      };
    },

    calculateAge(dateOfBirth) {
      return convertAge(dateOfBirth);
    },

    ageEnMois(dateOfBirth) {
      if (!dateOfBirth) return 0;
      const birth = new Date(dateOfBirth);
      const now = new Date();
      return (now.getFullYear() - birth.getFullYear()) * 12 + (now.getMonth() - birth.getMonth());
    },

    calculerDernieresMAJ() {
      const maxDate = arr =>
        arr.reduce((a, b) =>
          new Date(a.created_at) > new Date(b.created_at) ? a : b
        );

      const chiens = this.animaux.filter(a => a.type === "chien");
      const chats = this.animaux.filter(a => a.type === "chat");

      this.lastUpdateChien = chiens.length ? maxDate(chiens).created_at : null;
      this.lastUpdateChat = chats.length ? maxDate(chats).created_at : null;
    },

    formatDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return d.toLocaleDateString("fr-FR", { year: "numeric", month: "short", day: "2-digit" });
    }
  }
};
</script>

<style scoped src="../assets/css/animauxnew.css"></style>

